export default __webpack_public_path__ + "static/deeple-store-management_ipad.av1-a53303539056cf24ddeed8506e7e1fd6.mp4";